export const LOGIN_ONLY = 'login_only';

export const HAS_SERVICE_ACCESS = 'global';
export const HAS_SMS_MESSAGING = 'sms_messaging';

// TODO FLOW-TO-TS Convert to Enum
export type AccessControl =
  | typeof HAS_SERVICE_ACCESS
  | typeof HAS_SMS_MESSAGING;
